module.exports = __webpack_public_path__ + "img/gift-card-generic.8a05ca74.svg";